export const OPTIONS_PLACEHOLDER = 'placeholder';
export const ANY_OPTION = -999;